const TaskList = ({ children }) => {
	return <ul data-type="taskList">{children}</ul>;
};

export default TaskList;
